import React, {useContext} from 'react';
import {AppContext} from '../../contexts/AppContext';
import {getBookingUrl, getDetailPageUrl} from '../../helpers/accommodation';
import FormattedPrice from './FormattedPrice';
import clsx from 'clsx';
import {translate} from '../../helpers/base';

const roundPrice = (price, decimals = 0) => {
    let factor = Math.pow(10, decimals);
    return Math.round(price * factor) / factor;
};

const ratingFlower = (index) => {
    return (
        <i key={index} className="icon icon--uab-flower">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
                <path stroke="#000"
                      d="M11.672 13.052s.885 3.76 1.99 5.573c1.27 2.09 2.3 1.438 3.06.824.71-.575 1.442-2.532-1.165-4.537-1.144-.873-2.394-2.052-2.856-2.551m3.472 3.089s3.174 2.465 4.049 0c.875-2.466-2.212-3.377-2.212-3.377s-1.837-.69-4.8-.7m5.07.796s2.884.134 2.98-1.352c.106-1.621-.923-2.782-3.25-2.571m-4.943 1.947s3.606-1.065 5.154-2.043c1.549-.978 2.299-2.11.924-3.338-1.376-1.228-2.886-.105-2.886-.105M12.422 9.3s2.847-2.724 3.664-4.355c.818-1.63.847-2.753-.75-3.155-1.596-.403-2.192.46-2.914 1.592M11.47 8.83s.837-3.06.952-5.084c.116-2.024-.5-3.558-2.423-2.83-1.924.73-1.587 2.706-1.375 3.674m1.625 4.326S9.153 4.812 7.624 2.951c-1.53-1.86-2.857.048-3.05.336-.191.288-.691 1.717.636 2.83m4.116 3.472s-2.51-2.782-4.838-3.904c-2.327-1.122-2.779.902-2.827 1.41-.048.508.02 1.611 1.221 2.053m6.02 1.333S5.74 9.29 3.623 9.148c-2.115-.144-3.182.44-2.817 2.1.385 1.736 1.914 1.852 2.789 1.823m5.299-1.506s-2.933.403-4.991 1.352c-2.058.95-2.683 1.756-1.933 2.964.75 1.209 2.539 1.593 3.962.23m3.51-3.577s-1.837 1.62-3.299 3.318c-1.461 1.698-1.644 3.09-.865 3.665.779.575 3.26 1.515 4.472-2.677m.683-3.76s-.962 3.597-.78 5.909c.183 2.312 1.318 2.58 2.617 2.043 1.105-.46 1.577-1.746 1.115-2.878m-.183-7.184a2.19 2.19 0 0 1-2.192 2.187 2.19 2.19 0 0 1-2.193-2.187 2.19 2.19 0 0 1 2.193-2.187c1.21 0 2.192.98 2.192 2.187Z"/>
            </svg>
        </i>
    );
}

const ratingSun = (index) => {
    return (
        <i key={index} className="icon icon--uab-sun">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
                <g clipPath="url(#a)">
                    <path fill="#231F20"
                          d="M12.396 5.446c.762-1.812.092-5.907-1.514-5.403-1.608.502.64 4.554 1.514 5.403ZM.898 8.388c-.696 1.398 2.988.926 4.794 2.066.43-2.099-4.135-3.385-4.794-2.066Zm21.617 21.298c1.65-.51-1.424-3.192-1.812-5.573-2.029 1.275.254 6.053 1.812 5.573Zm.503-27.273c-.67-.873-3.35.466-3.099 4.344 0 0 3.77-3.47 3.099-4.344Zm-23 17.482c-.274 1.128 2.498 1.957 5.45-1.175 0 0-5.174.045-5.45 1.175Zm24.65-1.755s4.165 3.188 5.037 2.455c.872-.731-.867-3.122-5.037-2.455ZM8.406 27.272c-.81 1.07-1.876 2.329-.7 2.63 1.704.436 2.69-3.548 2.028-4.897 0 0-.517 1.197-1.328 2.267ZM29.232 9.165c-.522-1.222-2.45 1.417-4.324 1.953 1.159 1.437 4.817-.8 4.324-1.953ZM14.85 22.475c-3.63 0-6.573-2.953-6.573-6.595s2.943-6.595 6.573-6.595c3.63 0 6.571 2.953 6.571 6.595 0 3.643-2.942 6.596-6.571 6.596Zm0-15.449c-4.575 0-8.283 3.796-8.283 8.478 0 4.681 3.708 8.476 8.283 8.476 4.574 0 8.282-3.795 8.282-8.476 0-4.682-3.708-8.478-8.282-8.478Z"/>
                    <path fill="#FFE700" d="M14.85 22.476c3.63 0 6.572-2.954 6.572-6.596s-2.943-6.595-6.572-6.595c-3.63 0-6.573 2.953-6.573 6.595s2.943 6.596 6.573 6.596Z"/>
                </g>
                <defs>
                    <clipPath id="a">
                        <path fill="#fff" d="M0 0h30v30H0z"/>
                    </clipPath>
                </defs>
            </svg>
        </i>
    );
}

const AccommodationTeaser = ({data, hideButtons = false}) => {

    const {
        selectedFilters,
        locale,
        isUserLoggedIn,
        poolEnquiryData,
        filters,
    } = useContext(AppContext);

    const {
        title,
        accommodationId,
        trustYouScore,
        ratingScoreId,
        detailPageUrl,
        image,
        city,
        mainRegion,
        state,
        badges,
        experienceWorlds,
        price,
        // priceInfo,
        mealPlanInfo,
        bookable,
        kognitivId,
        trackingParams
    } = data;

    const isOnWishlist = window._wishlist.activeIds.includes(accommodationId);
    const isInEnquiryPool = poolEnquiryData.some(item => item.id === accommodationId);
    const isPrivatZuGast = window._config?.pzg || false;
    const flowers = ratingScoreId > 0 && ratingScoreId <= 5 ? ratingScoreId : 0;

    const getExperienceWorld = (id) => {
        return filters.global.experienceWorlds?.options.find(item => item.id === id) ?? null;
    };

    const customTrackingParams = {
        clickType: 'list',
        viewType: 'list',
        id: accommodationId
    };

    return (
        <article
            className="teaser-accommodation js-aa4y-single-enquiry js-custom-tracking"
            data-aa4y-kognitiv-id={kognitivId}
            data-custom-tracking-view="true"
            data-custom-tracking-click="true"
            data-custom-tracking-data-json={JSON.stringify(customTrackingParams)}
        >
            <div className="teaser-accommodation--inner">
                <div className="teaser-accommodation--image">
                    <div className="teaser-accommodation--icons">
                        {trustYouScore > 0 && <span className="trustyou-rating">
                            <span className="rating-box">{String(trustYouScore).replace('.', ',')}</span>
                            <span className="rating-logo">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 400">
                                  <path fill="#3b98db"
                                        d="M335.7 207.53v22.06h-15.45v-22.06l-21.54-37.12h17.52l11.81 24 11.81-24h17.52l-21.67 37.12ZM355.68 200c0 17.13 10.64 30.88 29.2 30.88s29.19-13.62 29.19-30.88-10.64-30.88-29.19-30.88-29.2 13.75-29.2 30.88m15.44 0c0-8.82 3.89-17.65 13.76-17.65s13.75 8.7 13.75 17.65-3.76 17.65-13.75 17.65S371.12 209 371.12 200M457.15 170.41v35.69c0 7.65-2.72 11.55-10.38 11.55s-10.38-3.9-10.38-11.55v-35.69H421v34.78c0 17.13 7.92 25.69 25.82 25.69s25.83-8.56 25.83-25.69v-34.78Z"/>
                                  <path fill="#2a5caa"
                                        d="M15.05 170.41v13.24h16.61v45.94H47.1v-45.94h16.61v-13.24ZM167.26 170.41v35.69c0 7.65-2.72 11.55-10.38 11.55s-10.38-3.9-10.38-11.55v-35.69h-15.44v34.78c0 17.13 7.91 25.69 25.82 25.69s25.82-8.56 25.82-25.69v-34.78ZM191.4 187.15c0 10.9 8.95 14.67 17.39 17.13s17 3.38 17 8.57c0 4.41-4.81 6.1-9.48 6.1-6.61 0-10.9-2.21-11.16-9.22h-15.44c0 15.18 12.2 21.15 25.69 21.15 13 0 25.83-4.8 25.83-19.85 0-10.64-8.57-14.66-17.13-17.13s-17.1-3.11-17.1-7.78c0-3.9 4.15-5.07 7.53-5.07 4.67 0 9.73 1.82 9.6 7.14h15.44c0-13.23-12.07-19.07-23.75-19.07-11.42 0-24.39 5.06-24.39 18M244.6 170.41v13.24h16.61v45.94h15.44v-45.94h16.61v-13.24ZM71.63 170.41v59.31h15.44V210h9.86l9.6 19.73h17.65l-12.72-21.93c6.1-2.86 9.74-8.57 9.74-18.17 0-14-10.38-19.08-21.41-19.08Zm15.44 12.33h10.38c4.67 0 8.3 2.21 8.3 7.79s-3.37 7.39-8.3 7.39H87.07Z"/>
                                  <path fill="#7cb342" d="M584.89 198.65h-19.63l-8.42 7.35v-35.4H585v28.05Z"/>
                                  <path fill="#ffa726" d="M549.83 198.65h-19.69l-8.42 7.35v-35.4h28.11Z"/>
                                  <path fill="#f06748" d="M514.76 198.65h-19.63l-8.42 7.35v-35.4h28.11l-.06 28.05Z"/>
                                </svg>
                            </span>
                        </span>}
                        {isUserLoggedIn ? <button
                            className={clsx('teaser--watchlist', 'js-wishlist__btn', isOnWishlist && 'is-active')}
                            data-wishlist-id={accommodationId}
                            data-tooltip="hover"
                            data-tooltip-content={translate(isOnWishlist ? 'accommodation-overview.accommodation.wishlist.remove' : 'accommodation-overview.accommodation.wishlist.add')}
                            data-tooltip-add={translate('accommodation-overview.accommodation.wishlist.add')}
                            data-tooltip-remove={translate('accommodation-overview.accommodation.wishlist.remove')}
                        >
                            <i className="icon icon--diverses-heart">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 31">
                                    <path stroke="#000" strokeWidth="2"
                                          d="M1 10.73C1 18.053 7 26.19 15 29c8-2.81 14-10.947 14-18.27C29 5.81 26.453 3 21.667 3 19 3 17 4.368 15 5.81 13 4.369 11 3 8.671 3 3.885 3 1 5.81 1 10.73Z"></path>
                                </svg>
                            </i>
                        </button> : <button className="teaser--watchlist" data-tooltip="click" data-tooltip-content={translate('accommodation-overview.accommodation.wishlist.login')}>
                            <i className="icon icon--diverses-heart">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 31">
                                    <path stroke="#000" strokeWidth="2"
                                          d="M1 10.73C1 18.053 7 26.19 15 29c8-2.81 14-10.947 14-18.27C29 5.81 26.453 3 21.667 3 19 3 17 4.368 15 5.81 13 4.369 11 3 8.671 3 3.885 3 1 5.81 1 10.73Z"></path>
                                </svg>
                            </i>
                        </button>}
                    </div>
                    <a href={getDetailPageUrl(detailPageUrl, selectedFilters)}>
                        <img src={image} alt={title} loading="lazy"/>
                    </a>
                    <button
                        type="button"
                        className={clsx('teaser--pool-enquiry', 'js-pool-enquiry__btn', isInEnquiryPool && 'is-active')}
                        data-pool-enquiry-data={JSON.stringify({
                            title: title,
                            imgSrc: image,
                            id: accommodationId,
                            kognitivId: kognitivId
                        })}
                    >
                        <span className="teaser--pool-enquiry--add">
                            {translate('accommodation-overview.accommodation.poolInquiry.add')} <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.402 45.402"><path d="M41.267 18.557H26.832V4.134A4.127 4.127 0 0 0 22.707 0a4.126 4.126 0 0 0-4.124 4.135v14.432H4.141a4.137 4.137 0 0 0-4.138 4.135 4.143 4.143 0 0 0 1.207 2.934 4.122 4.122 0 0 0 2.92 1.222h14.453V41.27c0 1.142.453 2.176 1.201 2.922a4.11 4.11 0 0 0 2.919 1.211 4.13 4.13 0 0 0 4.129-4.133V26.857h14.435c2.283 0 4.134-1.867 4.133-4.15-.001-2.282-1.852-4.15-4.133-4.15z"/></svg>
                        </span>
                        <span className="teaser--pool-enquiry--remove">
                            {translate('accommodation-overview.accommodation.poolInquiry.remove')} <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.402 45.402"><path d="M41.267 18.557H26.832V4.134A4.127 4.127 0 0 0 22.707 0a4.126 4.126 0 0 0-4.124 4.135v14.432H4.141a4.137 4.137 0 0 0-4.138 4.135 4.143 4.143 0 0 0 1.207 2.934 4.122 4.122 0 0 0 2.92 1.222h14.453V41.27c0 1.142.453 2.176 1.201 2.922a4.11 4.11 0 0 0 2.919 1.211 4.13 4.13 0 0 0 4.129-4.133V26.857h14.435c2.283 0 4.134-1.867 4.133-4.15-.001-2.282-1.852-4.15-4.133-4.15z"/></svg>
                        </span>
                    </button>
                </div>
                <div className="teaser-accommodation--content">
                    {badges.length > 0 && <div className="teaser-accommodation--type">
                        {badges.map(({label, text}, index) => {
                            if (text) {
                                return (
                                    <div key={'badge-' + index} className="type-pill" data-tooltip="hover" data-tooltip-content={text}>
                                        <span>{label}</span>
                                    </div>
                                );
                            }
                            return (
                                <div key={'badge-' + index} className="type-pill">
                                    <span>{label}</span>
                                </div>
                            )
                        })}
                    </div>}
                    <header>
                        <a href={getDetailPageUrl(detailPageUrl, selectedFilters)}>
                            <h2 className="teaser-accommodation--headline">{title}</h2>
                            <small>{[city, mainRegion, state].filter(Boolean).join(', ')}</small>
                        </a>
                    </header>
                    {flowers > 0 && <div className="teaser-accommodation--flowers">
                        {Array.from({length: flowers}).map((_, index) => isPrivatZuGast ? ratingSun(index) : ratingFlower(index))}
                    </div>}
                    {price && <div className="teaser-accommodation--price">
                        <p className="price h5">
                            <span>
                                <FormattedPrice value={roundPrice(price)} decimals={0} />
                                {mealPlanInfo && <i className="icon price-info" data-tooltip="hover" data-tooltip-content={mealPlanInfo}>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12">
                                      <path fill="#85A176" d="M7.36 10H8.8v1.2H3.2V10h1.416V4.737h-.974V3.537H7.36v6.462ZM4.616 1.353c0-.372.133-.699.398-.961C5.302.131 5.612 0 6.01 0c.377 0 .709.131.952.393.244.262.398.59.398.96 0 .372-.132.7-.398.94s-.575.392-.952.392c-.376 0-.708-.13-.974-.393-.287-.24-.42-.567-.42-.938Z"/>
                                    </svg>
                                </i>}
                            </span>
                        </p>
                        {/*<p className="price h5" data-tooltip={priceInfo}><span>Ab <FormattedPrice value={roundPrice(price)} decimals={0} /> pro Nacht</span></p>
                        {mealPlanInfo && <p className="price-subtext">({mealPlanInfo})</p>}*/}
                    </div>}
                    {experienceWorlds && <div className="teaser-accommodation--worlds">
                        {experienceWorlds.map(id => {
                            const experienceWorld = getExperienceWorld(id);
                            if(experienceWorld) {
                                const {theme, label} = experienceWorld;
                                return <span key={theme} className={clsx('world', 'theme--' + theme)} data-worldname={label}></span>
                            }
                            return null;
                        })}
                    </div>}
                    {/* TODO "more" info button?
                    <a href={getDetailPageUrl(detailPageUrl, selectedFilters)} className="btn btn-outline btn-sm">
                        {translate('accommodation-overview.accommodation.more')}
                    </a>*/}
                    {!hideButtons && <div className="teaser-accommodation--booking">
                        {bookable ?
                            <a href={getBookingUrl(kognitivId, trackingParams, selectedFilters, locale)} target="_blank" className="btn btn-primary btn-block" rel="noreferrer">
                                {translate('accommodation-overview.accommodation.book')}
                            </a> :
                            <button type="button" className="btn btn-outline btn-block js-aa4y-single-enquiry__btn">
                                {translate('accommodation-overview.accommodation.inquire')}
                            </button>
                        }
                    </div>}
                </div>
            </div>
        </article>
    );
};

export default AccommodationTeaser;
